function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "google",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape-2",
  transform: "translate(4.000000, 4.000000)",
  fill: "#ACACAC"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.67346939,7.28571429 L8.67346939,10.2 L13.5925656,10.2 C13.3943149,11.4507143 12.1056851,13.8671429 8.67346939,13.8671429 C5.71209913,13.8671429 3.29591837,11.4628571 3.29591837,8.5 C3.29591837,5.53714286 5.71209913,3.13285714 8.67346939,3.13285714 C10.3586006,3.13285714 11.4861516,3.83714286 12.1304665,4.44428571 L14.4846939,2.22214286 C12.9730321,0.837857143 11.0153061,0 8.67346939,0 C3.87827988,0 0,3.80071429 0,8.5 C0,13.1992857 3.87827988,17 8.67346939,17 C13.6793003,17 17,13.5514286 17,8.69428571 C17,8.13571429 16.9380466,7.71071429 16.8637026,7.28571429 L8.67346939,7.28571429 L8.67346939,7.28571429 Z",
  id: "Shape"
})));

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "google") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.04701f9c.svg";
export { ForwardRef as ReactComponent };